import React, { Component } from 'react'
import CheckBox from 'shared-web/src/components/CheckBox'
import { pluralize } from 'humanize-plus'

import DropDown from 'components/DropDown'

import styles from './style.styl'

const Divider = (
  <div
    style={{
      borderBottom: "1px solid #EEEEEE",
      marginBottom: 10,
      width: 145
    }}
  />
)

const BlueCaret = (
  <img
    src={require('images/svg/down-caret-blue.svg')}
    style={{ marginLeft: 3 }}
  />
)

class Filters extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showTypeFilters: false,
    }
  }

  hideTypeFilters = () => {
    this.setState({ showTypeFilters: false })
  }

  toggleTypeFilters = () => {
    this.setState({ showTypeFilters: !this.state.showTypeFilters })
  }

  onAllActivityClick = () => {
    this.props.updateFilter(this.props.filter.clear())
  }

  onFilterClick = (id, checked) => {
    if (checked) {
      this.props.updateFilter(this.props.filter.set(id, true))
    } else {
      this.props.updateFilter(this.props.filter.delete(id))
    }
  }

  renderTypeFilterRow(key, display) {
    return (
      <div className="flex dsg-Regular">
        <CheckBox
          checked={this.props.filter.get(key)}
          id={key}
          onChange={this.onFilterClick}
        />
        <span className="dsg-Body">&nbsp;&nbsp;{display}</span>
      </div>
    )
  }

  renderDropDown() {
    if (!this.state.showTypeFilters) return
    return (
      <DropDown
        onClickOutside={this.hideTypeFilters}
        className={styles.Dropdown}
      >
        <div className="flex dsg-Regular">
          <CheckBox
            checked={this.props.filter.size === 0}
            id="all-activity"
            onChange={this.onAllActivityClick}
          />
          <span className="dsg-Body">&nbsp;&nbsp;All activity</span>
        </div>
        {Divider}
        {this.renderTypeFilterRow('NOTE', 'Notes')}
        {this.renderTypeFilterRow('CONVERSATION', 'Conversations')}
        {this.renderTypeFilterRow('CAMPAIGN', 'Campaigns')}
        {this.renderTypeFilterRow('PROPERTY', 'Properties')}
        {this.renderTypeFilterRow('EVENT', 'Triggered Activities')}
      </DropDown>
    )
  }

  renderSelectionPhrase() {
    if (this.props.filter.size) {
      return `${this.props.filter.size} ${pluralize(this.props.filter.size, 'activity type', 'activity types')}`
    } else {
      return 'all activity'
    }
  }

  render() {
    return (
      <div className="dsg-Body" style={{ marginBottom: 10 }}>
        Displaying&nbsp;
        <span
          style={{
            position: 'relative'
          }}
        >
          <span
            onClick={this.toggleTypeFilters}
            className="link"
          >
            {this.renderSelectionPhrase()}
            {BlueCaret}
          </span>
          {this.renderDropDown()}
        </span>
      </div>
    )
  }
}

export default Filters



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/Filters/index.js